import { Component, OnInit } from '@angular/core';
import { GatePass } from './../../_models/gate_pass';
import { AuthService } from './../../_services/auth.service';

@Component({
  selector: 'app-free-download',
  templateUrl: './free-download.component.html',
  styleUrls: ['./free-download.component.css']
})
export class FreeDownloadComponent implements OnInit {
  gatePass = new GatePass()
  constructor(public authService:AuthService) { }

  ngOnInit(): void {
    this.gatePass = this.authService.gatePass.getValue()
  }
  downloadapp(){
    window.location.href = 'https://play.google.com/store/apps/details?id=com.boldungu.boldlet';
   }
}
